<!--
 * @Description: 订单管理-查看详情
 * @Autor: zczhang
 * @Date: 2021-03-15 14:29:13
 * @LastEditors: zczhang
 * @LastEditTime: 2021-03-15 17:44:51
-->

<template>
    <div class="orderManageDetail">
        <el-dialog title="查看" :visible="show" width="30%" @close="cancel">
            <div class="infoBox">
                <div class="item">
                    <div class="key">姓名：</div>
                    <div class="value">{{ datas.customerName }}</div>
                </div>

                <div class="item">
                    <div class="key">餐饮类型：</div>
                    <div class="value">
                        <span v-if="datas.takeWay == 0">送餐</span>
                        <span v-if="datas.takeWay == 1">堂食</span>
                        <span v-if="datas.takeWay == 2">自取</span>
                    </div>
                </div>

                <div class="item">
                    <div class="key">送餐人员：</div>
                    <div class="value">
                        {{ datas.personName }}
                    </div>
                </div>

                <div class="item">
                    <div class="key">状态：</div>
                    <div class="value">
                        <span v-if="datas.istake == 1">用餐完成</span>
                        <span v-if="datas.istake == 0">用餐未完成</span>
                        <span v-if="datas.istake == 2">送餐中</span>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        datas: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {}
    },
    methods: {
        cancel() {
            this.$parent.detailClose()
        },
    },
    mounted() {},
}
</script>

<style scoped>
.orderManageDetail {
    width: 30%;
}

.infoBox {
    width: 100%;
}

.item {
    height: 45px;
    width: 100%;
    margin: 6px 0;
    display: flex;
    font-family: Montserrat, Helvetica Neue, Hiragino Sans GB, LiHei Pro, Arial,
        sans-serif;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.key {
    width: 80px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.value {
    width: calc(100% - 80px);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left: 10px;
}
</style>